var MOBILE_SWIPE_ANIMATIONS = {
    EXPAND: 'EXPAND',
    FADE: 'FADE',
    CAROUSEL: 'CAROUSEL',
    CROSSFADE: 'CROSSFADE',
};
export default MOBILE_SWIPE_ANIMATIONS;
//# sourceMappingURL=mobileSwipeAnimations.js.map